import { Requestor } from '@viddsee/server-api-client';
import loginController from '@/scripts/libs/login/controller';
import { isInternalUrl, resolveUrl } from '@/scripts/helpers/url-helper';

export const shouldProvideAuthorizationHeader = (url: string | undefined, baseUrl: string | undefined): boolean => {
  const resolvedUrl = resolveUrl(url || '', baseUrl || location.origin);
  return isInternalUrl(resolvedUrl);
};

export const authGetter: Requestor.BaseApiAuthConfig['getter'] = (config) => {
  if (!shouldProvideAuthorizationHeader(config.url, config.baseURL)) {
    return null;
  }

  return {
    header: {
      accessToken: loginController.token || '',
      tokenType: 'Token',
    },
  };
};
